/**
 * Returns true when a user is blocked/disabled and should be hidden from pickers.
 */
export const isBlockedUser = (user) => {
  if (!user) return true;

  if (user.disabled_at) return true;
  if (user.is_blocked === true || user.isBlocked === true) return true;
  if (user.disabled === true || user.isDisabled === true) return true;

  return false;
};

export const filterActiveUsers = (users = []) =>
  users.filter((user) => user && !isBlockedUser(user));
